// produces Jan 7, 1992 for en-US
export const SHORT_MONTH_DATE_ONLY = {
  year: 'numeric',
  day: 'numeric',
  month: 'short'
};

// produces 1/7/1992 for en-US
export const DEFAULT_OPTIONS = {};

// 4/12/2019, 5:38 AM
export const DATE_TIME = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
};

// https://github.com/smallwins/spacetime/wiki/Formatting
// LL: "MMMM Do YYYY"
export const LONG_DATE_FORMAT = 'nice';
export const MONTH_DAY_DISPLAY = '{month-short} {date-ordinal}';

// L: 09/04/1986 (based on locale)
export const SHORT_DATE_FORMAT = 'numeric-us';
export const SHORT_DAY_NAME_FORMAT = 'day-short';
export const SHORT_TIME = 'time';
export const SHORT_ISO_DATE = 'iso-short';
export const HOURS_MINUTES_UNIX = 'hh:mm';
export const SHORT_TIME_UNIX = 'h:mm a';
export const SHORT_DATE = '{month-short} {date}';
export const SHORT_DATE_AND_TIME = `${SHORT_DATE}, {time}`;
export const NUMERIC_US_DATETIME = '{numeric-us}, {time}';

export const DAY_NAME_FORMAT = 'day';
export const DAY_DATE_NUMBER = 'date';
export const MONTH_ABBR = 'month-short';
export const LONG_DAY_AND_DATE = '{day}, {month} {date} {year}';
export const SUMMARY_DATE_FORMAT = `{day-short}, ${SHORT_DATE}`;
export const SUMMARY_DATE_YEAR_FORMAT = `{day-short}, ${SHORT_DATE}, {year}`;

// format directives
export const START_OF_DAY = 'START_OF_DAY';
export const END_OF_DAY = 'END_OF_DAY';
